import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-errormodal',
  templateUrl: './errormodal.component.html',
  styleUrl: './errormodal.component.scss'
})
export class ErrormodalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<ErrormodalComponent>) {}
  dropdownOptions: string[] = [];
  showstarcancelno:boolean =false;
  showstarcancelyes:boolean=false;
  starNotExist:boolean =false;
  ngOnInit(): void {
    // this.extractDropdownOptions();
    if(this.data.showFullBlock != true){
      this.groupInvalidRows(this.data.invalidRows);
    }
    //   if(this.data.add_star == true){
    //  this.showstarcancelno = true;
    //   this.showstarcancelyes =true;
    // }
    // if(this.data.add_star == false){
    //   this.showstarcancelno = true;
    //   this.showstarcancelyes =false;
    // }
    if (this.data.add_star) {
  this.showstarcancelno = true;
  this.showstarcancelyes = this.data.add_star === true;
  this.starNotExist = false;
} else {
  this.starNotExist = true;
  this.showstarcancelno = false;
  this.showstarcancelyes = false;
}
if (this.data.is_merge) {
  this.showmergeorderModal = this.data.is_merge === true;
} else {
  this.showmergeorderModal = false;
}

if ( this.data.is_merge ||  this.data.add_star) {
  this.starNotExist = false;
}
  }
  groupedInvalidRows:any;
groupInvalidRows(invalidRows: any[]) {
  const grouped: any[] = [];

  invalidRows.forEach(row => {
    const rowNumber = row.row_number;
    const orderNoMatch = row.errors.match(/Order No (\d+)/);
    const orderNo = orderNoMatch ? orderNoMatch[1] : '';

    const existing = grouped.find(g => g.row_number === rowNumber);

    const errorEntry = {
      order_no: orderNo,
      message: row.errors
    };

    if (existing) {
      existing.errors.push(errorEntry);
    } else {
      grouped.push({
        row_number: rowNumber,
        column_data: row.column_data,
        errors: [errorEntry]
      });
    }
  });

  this.groupedInvalidRows = grouped;
}

  // extractDropdownOptions(): void {
  //   this.data.invalidRows.forEach((row: any, index: number) => {
  //     // Extract addresses from the error message using regex
  //     const errorMessage = row.errors;
  //     const match = errorMessage.match(/Please select the address or add new one: ([a-zA-Z\s,]+)\./);
  
  //     if (match && match[1]) {
  //       // Split the addresses by commas and trim whitespace
  //       row.addressOptions = match[1].split(',').map((address: string) => address.trim());
  //     } else {
  //       row.addressOptions = [];
  //     }
  //   });
  
  //   console.log(this.data.invalidRows, 'this.apiResponse.invalidRows');
  // }
  showOrderNoConflictModal = false;
  showmergeorderModal =false;
conflictingOrderIndexes = [];
  extractDropdownOptions(): void {
    if (!this.data.invalidRows || this.data.invalidRows.length === 0) {
      return;
    }
  
    this.data.invalidRows.forEach((row: any) => {
      const errorMessage = row.errors;
  
      // Log the error message for debugging
      console.log('Error Message:', errorMessage);
  
      // Match the error message using regex
      const match = errorMessage.match(/Please select the (address|company) or add a new one from the following:\n([\s\S]+)/);
  
      // Log the regex match result
      console.log('Regex Match:', match);
  
      if (match && match[2]) {
        // Split options by the numbered list (e.g., "1. ", "2. ")
        row.options = match[2]
          .split(/\d+\.\s+/) // Split by "1. ", "2. ", etc.
          .map((option: string) => option.trim()) // Remove whitespace
          .filter((option: string) => option); // Remove empty values
  
        // Flag to determine if it's for address or company
        row.isAddress = match[1] === 'address';
      } else {
        row.options = [];
        // console.error('Error message does not match expected format:', errorMessage);
      }
const orderNoMatch = errorMessage.match(/Order No ([\w-]+) already exists/);
const duplicateOrderNo = orderNoMatch ? orderNoMatch[1] : null;

if (
  errorMessage.includes('order_no')  && duplicateOrderNo
) {
  const orderNos = row.column_data.order_no.split(',').map((no: string) => no.trim());
  const matchingNos = orderNos.filter((no: string) => no.replace(/\*$/, '') === duplicateOrderNo);

  // Show modal if at least one matching value does NOT have a '*'
  const needsStar = matchingNos.some((no: string | string[]) => !no.includes('*'));

  if (needsStar) {
    this.showOrderNoConflictModal = true;
  }
}

if(errorMessage.includes('pending_order_exist')){
  this.showmergeorderModal =true
}
if(errorMessage.includes('duplicate_company_address')){
  this.showmergeorderModal =true
}

    });
  }
  
  
  
  
  
  copyText(val: string){
    let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
  }
getCleanError(error: string): string {
  return error
    .replace(/^order_no:\s*/i, '') // remove "order_no: " at the beginning
    .replace(/pending_order_exist:/gi, '') // remove "pending_order_exist" anywhere
    .replace(/duplicate_company_address:/gi, '') // remove "duplicate_company_address" anywhere
    .trim(); // remove leading/trailing whitespace
}

getDuplicateOrderNo(error: string): string {
  const match = error.match(/Order No (\d+) already exists/);
  return match ? match[1] : '';
}



handleAsteriskConfirmation(): void {
  this.dialogRef.close(this.data);
}

handleCancel(): void {
  this.dialogRef.close(null); // no click, kuch na bhejna
}
handleCancel1(): void {
  this.dialogRef.close('nulles'); // no click, kuch na bhejna
}
handleCancel2(): void {
  this.dialogRef.close('Remain_same'); // no click, kuch na bhejna
}
}
